// Sacred Report wrapper (v5) — thin layer over SACRED_REPORTS_V5.
// Renders NAME placeholder with customer first name and dynamically substitutes
// the calendar year tokens inside `cur` (2026 → current year) and `fut` (2027 → next year).

import { SACRED_REPORTS_V5 } from "./sacredReportsV5";
import { nnTemplate } from "./nameNumberTemplates";

export const SACRED_REPORTS = SACRED_REPORTS_V5;

const TEMPLATE_CUR_YEAR = 2026;
const TEMPLATE_NEXT_YEAR = 2027;

function replaceName(str, first) {
  return String(str || "").replace(/NAME/g, first);
}

function replaceYears(str, curYr, nxtYr) {
  return String(str || "")
    .replace(new RegExp(String(TEMPLATE_CUR_YEAR), "g"), String(curYr))
    .replace(new RegExp(String(TEMPLATE_NEXT_YEAR), "g"), String(nxtYr));
}

/**
 * @param {number|string} lifePath
 * @param {string} name
 * @param {object} [opts]
 * @param {number} [opts.currentYear] current calendar year (defaults to now)
 * @param {number} [opts.nextYear] next calendar year
 * @param {number|string} [opts.nameNumber] customer name number — drives the `nn` section text
 */
export function renderReport(lifePath, name, opts = {}) {
  const rawFirst = (name || "").trim().split(/\s+/)[0] || "Beautiful Soul";
  // Capitalise the stored first name so legacy records saved in lower case still
  // read correctly in sentences like "Ma, your strengths are kinetic..."
  const first = rawFirst.charAt(0).toUpperCase() + rawFirst.slice(1).toLowerCase();
  const curYr = opts.currentYear || new Date().getFullYear();
  const nxtYr = opts.nextYear || curYr + 1;
  const key = String(lifePath);
  const tpl = SACRED_REPORTS_V5[key] || SACRED_REPORTS_V5["1"];

  const str = (k, applyYear = false) => {
    let v = replaceName(tpl[k], first);
    if (applyYear) v = replaceYears(v, curYr, nxtYr);
    return v;
  };

  const arr = (k) => (tpl[k] || []).map((line) => replaceName(line, first));

  // Name Number section comes from a SEPARATE template keyed on the customer's
  // name number (NOT the Life Path). Falls back to LP template's nn field if
  // no name number is supplied (for backward compatibility with old callers).
  const nnText = opts.nameNumber != null
    ? replaceName(nnTemplate(opts.nameNumber).text, first)
    : str("nn");

  const report = {
    // New v5 keys
    soul: str("soul"),
    lp: str("lp"),
    nn: nnText,
    ch: str("ch"),
    cur: str("cur", true),
    fut: str("fut", true),
    kar: str("kar"),
    gifts: str("gifts"),
    prac: str("prac"),
    dos: arr("dos"),
    dont: arr("dont"),
    aff: str("aff"),
  };

  // Backward-compatible aliases (older callers used these names)
  report.lifepath = report.lp;
  report.namenum = report.nn;
  report.characteristics = report.ch;
  report.current = report.cur;
  report.future = report.fut;
  report.karma = report.kar;
  report.donts = report.dont;
  report.affirmation = report.aff;

  return report;
}
